import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useEffect, useState, useCallback } from "react";
import { Box } from "@mui/material";
import CalculatorMobileLayout from "./mobile/calculatorMobileLayout";
import CalculatorWebLayout from "./web/calculatorWebLayout";
import { GetCalculatorInfo } from "../../../context/calculator/tour/calculatorProvider";
import { useNavigate } from "react-router-dom";
import { useGetSharedDataMutation, useGetVehicleChargeMutation } from '../../../services/calculatorApi';
import SnackbarComponent from '../../../components/snackBar/snackbarComponent';
import { MONTH, VEHICLE } from '../../../data/data';
import { GetAuth } from '../../../context/auth/authProvider';
import { GetPastTrips } from '../../../context/trip/tripProvider';

const TourCalculatorLayout = ({
    navOption,
    setShowTabView
}) => {
    const [formView, setFormView] = useState(false);
    const [defaultData, setDefaultData] = useState({
        id: null,
        month: null,
        vehicle: null,
        days: 0,
        batta: true,
        distance: 0
    });

    const [showManualDistance, setShowManualDistance] = useState(false);

    const [snackBar, setSnackBar] = useState({
        message: "",
        open: false,
        color: ""
    });

    const calculator = GetCalculatorInfo();
    const auth = GetAuth();
    const trip = GetPastTrips();

    const navigate = useNavigate();

    const formSchema = yup.object().shape({
        distance: yup.number().required('Distance is required').typeError('Invalid distance').moreThan(0, 'Distance should be greater than 0')
    });
        
    const defaultValues = {
        distance: null
    };
        
    const formMethods = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: defaultValues
    });
        
    const {
        setValue,
        reset: reset,
        handleSubmit: handleSubmit,
        formState: { isSubmitting: isSubmitting },
        watch
    } = formMethods;
        
    const values = watch();

    const onSubmit = handleSubmit(async(data) => {
        console.log(data);
    });

    useEffect(() => {
        console.log("Rendered...");

        if(trip.editTourData){
            console.log(trip.editTourData);
            console.log(calculator.calculatorInfo);

            setDefaultData({
                id: trip.editTourData.id,
                month: trip.editTourData.month,
                vehicle: trip.editTourData.vehicle,
                days: trip.editTourData.days,
                batta: trip.editTourData.batta,
                distance: trip.editTourData.distance
            });

            setValue('distance', trip.editTourData.distance);
            
            calculator.updateDistance(trip.editTourData.distance);
            calculator.updateTripName(trip.editTourData.tripName);

            if(trip.editTourData.locations?.length > 0){
                const coordinates = [];

                for(let i = 0; i < trip.editTourData.locations.length; i++){
                    const loc = trip.editTourData.locations[i];
                    coordinates.push(typeof loc === 'string' ? JSON.parse(loc) : loc);
                }

                trip.setActiveTour(coordinates);

                calculator.updateCoordinates(coordinates);
                calculator.updateTime({
                    hour: trip.editTourData.hour ?? trip.editTourData.time?.hour ?? 0,
                    minute: trip.editTourData.minute ?? trip.editTourData.time?.minute ?? 0
                });
            }
            else{
                calculator.updateTime({hour: 0, minute: 0});
            
                setShowManualDistance(true);
            }
        }
        else if(calculator.calculatorInfo.distance === 0){
            setShowManualDistance(true);
        }
    }, []);

    useEffect(() => {
        console.log("AAAAA")
        console.log(trip.editTourData);
        console.log(values.distance);

        if(!formView && values.distance !== null && (trip.editTourData === null || trip.editTourData?.locations?.length === 0)){
            setShowManualDistance(true);
        }
    }, [formView]);

    const [
        getSharedData, 
        {
            isLoading: isLoadingGetSharedData,
            isSuccess: isSuccessGetSharedData,
            data: sharedData,
            isError: isErrorGetSharedData,
            error: errorGetSharedData
        }
    ] = useGetSharedDataMutation();

    const [
        getVehicleCharge, 
        {
            isLoading: isLoadingGetVehicleCharge,
            isSuccess: isSuccessGetVehicleCharge,
            data: vehicleCharge,
            isError: isErrorGetVehicleCharge,
            error: errorGetVehicleCharge
        }
    ] = useGetVehicleChargeMutation();

    useEffect(() => {
        if(vehicleCharge && sharedData){
            console.log(sharedData);
            console.log(vehicleCharge);

            calculator.updatePerKmRate(vehicleCharge.amount);
            calculator.updateSharedData(sharedData);

            setFormView(true);
            setShowTabView(false);
        }
    }, [sharedData, vehicleCharge]);
    
    useEffect(() => {
        if(isErrorGetSharedData && errorGetSharedData){
            console.log(errorGetSharedData);
    
            setSnackBar({
                message: errorGetSharedData?.data?.message ?? "Something went wrong!",
                color: "red",
                open: true
            });
        }
    }, [isErrorGetSharedData, errorGetSharedData]);

    useEffect(() => {
        if(isErrorGetVehicleCharge && errorGetVehicleCharge){
            console.log(errorGetVehicleCharge);
    
            setSnackBar({
                message: errorGetVehicleCharge?.data?.message ?? "Something went wrong!",
                color: "red",
                open: true
            });
        }
    }, [isErrorGetVehicleCharge, errorGetVehicleCharge]);

    const getVehicleID = useCallback((vehicleName) => {
        let id = 0;
        
        for(let i = 0; i < VEHICLE.length; i++){
            if(VEHICLE[i].value === vehicleName){
                id = VEHICLE[i].id;
                break;
            }
        }

        return id;
    }, []);

    const getMonthID = useCallback((month) => {
        let monthID = 0;

        for(let i = 0; i < MONTH.length; i++){
            if(MONTH[i].value === month){
                monthID = MONTH[i].id;
                break;
            }
        }

        return monthID;
    }, []);

    const moveToFormView = useCallback((month, vehicle, days, batta, distance) => {
        console.log("Distance: " + distance + ", Month: " + month + ", Vehicle: " + vehicle + ", Days: " + days + ", Batta: " + batta);

        let id = null;

        if(trip.editTourData){
            id = trip.editTourData.id
        }

        console.log("Id: " + id);

        setDefaultData({
            id: id,
            month: month,
            vehicle: vehicle,
            days: days,
            batta: batta,
            distance: distance
        });

        calculator.updateFiltersData(month, vehicle, days, batta, id);
        calculator.updateDistance(distance);

        getSharedData({staffId: auth?.currentUser?.staffID});

        getVehicleCharge({
            month: getMonthID(month), 
            vehicle: getVehicleID(vehicle),
            staffId: auth?.currentUser?.staffID
        });
    }, [calculator]);
        
    const backToFilterView = useCallback(() => {
        setFormView(false);
        setShowTabView(true);
    }, [defaultData]);

    return (
        <>
            <Box
                width='100%'
            >
                <Box 
                    sx={{
                        display: {xs: 'block', lg: 'none'}
                    }}
                >
                    <CalculatorMobileLayout 
                        formView={formView}
                        defaultData={defaultData}
                        backToFilterView={backToFilterView}
                        moveToFormView={moveToFormView}
                        buttonLoading={isLoadingGetSharedData || isLoadingGetVehicleCharge}
                        allowDistanceEdit={showManualDistance}
                    />
                </Box>

                <Box 
                    sx={{
                        display: {xs: 'none', lg: 'block'},
                        pb: 5
                    }}
                >
                    <CalculatorWebLayout 
                        navOption={navOption}
                        formView={formView}
                        defaultData={defaultData}
                        backToFilterView={backToFilterView}
                        moveToFormView={moveToFormView}
                        buttonLoading={isLoadingGetSharedData || isLoadingGetVehicleCharge}
                        allowDistanceEdit={showManualDistance}
                    />
                </Box>
            </Box>

            <SnackbarComponent 
                message={snackBar.message}
                color={snackBar.color}
                open={snackBar.open}
                handleClose={() => setSnackBar({
                    message: "",
                    open: false
                })}
            />
        </>
    );
}

export default TourCalculatorLayout;